import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { business, businessSchema, websiteSchema } from '../seo/business';
import { normalizePageSchema, resolveCanonical } from '../seo/pageSchema';
import { setHeadTag, setSchema } from '../seo/headManager';

const SEO = ({ title, description, keywords, image = businessSchema.image, canonicalUrl, canonicalPath, structuredData, robots = 'index, follow', pageType = 'website' }) => {
  const { pathname } = useLocation();
  const canonical = resolveCanonical(pathname, canonicalUrl, canonicalPath);
  const serialized = JSON.stringify(normalizePageSchema(structuredData, canonical) || null);
  useLayoutEffect(() => {
    const owner = Symbol('page-seo');
    setHeadTag('title', 'title', {}, title);
    setHeadTag('link[rel="canonical"]', 'link', { rel: 'canonical', href: canonical });
    const tags = {
      description, robots, ...(keywords ? { keywords } : {}),
      'og:type': pageType, 'og:title': title, 'og:description': description,
      'og:url': canonical, 'og:image': image, 'og:site_name': business.name,
      'twitter:card': 'summary_large_image', 'twitter:title': title,
      'twitter:description': description, 'twitter:url': canonical, 'twitter:image': image
    };
    // Remove obsolete property-based Twitter tags and route-specific keywords.
    document.head.querySelectorAll('meta[property^="twitter:"]').forEach((node) => node.remove());
    if (!keywords) document.head.querySelectorAll('meta[name="keywords"]').forEach((node) => node.remove());
    Object.entries(tags).forEach(([key, content]) => {
      const attribute = key.startsWith('og:') ? 'property' : 'name';
      setHeadTag(`meta[${attribute}="${key}"]`, 'meta', { [attribute]: key, content });
    });
    setSchema('site-business-schema', businessSchema, owner);
    setSchema('site-website-schema', websiteSchema, owner);
    const cleanupPage = setSchema('page-structured-data', JSON.parse(serialized), owner);
    document.documentElement.dataset.seoPath = pathname;
    return cleanupPage;
  }, [pathname, canonical, title, description, keywords, image, robots, pageType, serialized]);
  return null;
};
export default SEO;